import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LayoutBtnFloatingComponent } from './components/layout-btn-floating/layout-btn-floating.component';
import { LayoutFooterComponent } from './components/layout-footer/layout-footer.component';
import { LayoutNavbarMenuComponent } from './components/layout-navbar-menu/layout-navbar-menu.component';
import { LayoutSidebarMenuComponent } from './components/layout-sidebar-menu/layout-sidebar-menu.component';
import { ContractComponent } from './components/contract/contract.component';
import { ApiConfig } from './services/config/api.config';
import { SessionService } from './services/session.service';
import { AuthService } from './services/auth.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DataContractComponent } from './components/data-contract/data-contract.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [ LayoutBtnFloatingComponent, LayoutFooterComponent, LayoutNavbarMenuComponent, LayoutSidebarMenuComponent, ContractComponent, SpinnerComponent, FileUploadComponent, DataContractComponent],
  exports: [
    LayoutBtnFloatingComponent, 
    LayoutFooterComponent, 
    LayoutNavbarMenuComponent, 
    LayoutSidebarMenuComponent,
    ContractComponent,
    SpinnerComponent,
    FileUploadComponent,
    DataContractComponent
  ],
  providers: [
    ApiConfig,
    AuthService,
    SessionService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /app/src/app/shared/shared.module.ts